import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { AccessUserInfo, LabRequestDetail, LabRequestHistory, LabResult, UserDetail, UserLocationFacility } from 'src/app/models';
import { LabRequestService, LabRequisitionService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'bart-lab-result-history',
  templateUrl: './lab-result-history.component.html',
  styleUrls: ['./lab-result-history.component.scss']
})
export class LabResultHistoryComponent implements OnInit {
  
  selectLabResultRow:LabResult[]=[];
  public userInfo: UserDetail;
  labRequestId?:number;
  labRequisitionId?:number;
  selectedFacilityDisplayName:string;
  selectedFacilityMasterId:number;
  userLocationFacilities :UserLocationFacility []= [];
  labResultDetails:LabResult;
  printPDF=false;
  constructor
  (
    private _loaderService: LoaderService,
    private _dynamicDialogRef: DynamicDialogRef,
    private dynamicConfig : DynamicDialogConfig,
    private _labRequisitionService: LabRequisitionService,
    private _userService:UserService
  ) { }

  ngOnInit() 
  {
    
     this.userInfo = AccessUserInfo.getUserInfo();
     this.labRequestId=this.dynamicConfig.data.rowData.LabRequestID;
     this.labRequisitionId=this.dynamicConfig.data.rowData.LabRequisitionID;
     this.labResultDetails=this.dynamicConfig.data.rowData;
     this.userLocationFacilities = this.dynamicConfig.data.userLocationFacilities
     this.selectedFacilityMasterId=this.dynamicConfig.data.selectedFacilityMasterId  
  }
 
  closePopup() {
    this._dynamicDialogRef.destroy();
     //#region User Action Audit
     this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LAB_RESULTS,
      screenPath:location.pathname,
      key:'LabRequestID',
      value:this.labRequestId.toString(),
      eventDescription:UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_POPUP_CLOSE_CLICKED
    }); 
    //#endregion
    
  }
  printLabResultPDF()
  {
    this._loaderService.show();
    this.printPDF=true;
//#region User Action Audit
this._userService.logUserAction({
  userName:this.userInfo.userName,
  userAction:UserAction.BUTTON_CLICKED,
  screenName:ScreenName.LAB_RESULTS,
  screenPath:location.pathname,
  key:'LabRequisitionID',
  value:this.selectLabResultRow.map(x => x.LabRequisitionID).join(","),
  eventDescription:UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_PRINT_CLICKED
}); 
//#endregion


  }
  printPDFLoaded()
  {
    this.printPDF=false; 
    this._loaderService.hide();     
  }  
}
